module.exports = __webpack_public_path__ + "static/media/summarize.1d1fc806.mp3";